import http from '../_http'

const group = {
  //default
  summaryGroup : (m) => { return http.get(`manager/management/group/summary`, m); },
  listGroup : (m) => { return http.post(`manager/management/group/list`, m); },
  detailGroup : (m) => { return http.get(`manager/management/group/${m.id}`); },
  infoGroup : (m) => { return http.get(`manager/management/group/info/${m.id}`); },
  resetGroup : (m) => { return http.get(`manager/management/group/reset/ip/${m.id}`); }, // cmd : mail.ip.reset

  //crud
  insertGroup : (m) => { return http.post(`manager/management/group`, m); },
  updateGroup : (m) => { return http.put(`manager/management/group`, m); },
  deleteGroup : (m) => { return http.delete(`manager/management/group/${m.id}`); },

  //credit
  creditGroup : (m) => { return http.get(`manager/management/group/credit`, m); },
  
  //import Partner Site
  plusCredit : (m) => { return http.get(`manager/management/group/credit/plus`, m);},
  minusCredit : (m) => { return http.get(`manager/management/group/credit/minus`, m); },
}

export default group

export { group }